<template>
	<div class="sf-input-group-wrapper">
		<span class="sf-input-group-wrapper__label">{{ getMessage_('MWCC000106') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<el-option label="ALL" value="ALL" selected></el-option>
				<el-option v-for="(useYn, index) in useYnList" :label="useYn.commCdName" :value="useYn.commCd" :key="index"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/GridFreeForm/store/helpers';
export default {
	data() {
		return {
			data: ''
		};
	},
	created() {
		this.searchParams.useYn || this.setSearchParam_({ key: 'useYn', value: 'Y' });
		this.data = this.searchParams.useYn;
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'useYn', value: value });
			this.$emit('search');
		}
	}
};
</script>

<style></style>
